<div class="text-white">
  <div class="text-xl">
    {{'limitingAccess'|translate}}
  </div>
  <div class="mt-2">{{'limitingAccessDescPart1'|translate}}</div>
  <div> {{'limitingAccessDescPart2'|translate}}</div>
  <div class="mt-2">{{'limitingAccessDescPart3'|translate}}</div>
  <div> {{'limitingAccessDescPart4'|translate}}</div>

</div>

<div mat-dialog-actions>
  <div class="mt-4 flex">
    <app-button [isActive]="true" innerTextClasses="text-sm mx-6" spinnerClasses="mx-7 my-1.5"
                label="{{'labels.close' | translate  | titlecase}}" (click)="onContact()"></app-button>
  </div>
</div>
